<template>
  <v-container class="recipe-editor-container">
    <v-row justify="start" no-gutters>
      <v-btn exact text :to="{ name: 'RecipeProductsIndex' }">
        <v-icon small left>fa-chevron-left</v-icon>Retour
      </v-btn>
    </v-row>
    <section class="editor" v-if="product">
      <v-row justify="space-between" align="center" class="mb-1 mt-3">
        <v-col cols="12">
          <RecipeProductTagsEditor
            v-model="product.data.tags"
          ></RecipeProductTagsEditor>
        </v-col>
      </v-row>
      <v-tabs
        show-arrows
        slider-color="primary"
        v-model="tabs"
        background-color="transparent"
        class="mb-3"
      >
        <v-tab>
          <v-icon left small>fa-clipboard-list</v-icon>Informations
        </v-tab>
        <v-tab-item :eager="true">
          <v-card>
            <v-card-text>
              <RecipeProductFields
                :nom.sync="product.nom"
                :est_intermediaire.sync="product.est_intermediaire"
                v-bind.sync="product.data"
                :valid.sync="valid"
              ></RecipeProductFields>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab> <v-icon left small>fa-tag</v-icon>Prix </v-tab>
        <v-tab-item :eager="true">
          <v-card>
            <v-card-text>
              <RecipeProductPriceInput
                v-bind.sync="product.data"
                :valid.sync="validPrice"
              ></RecipeProductPriceInput>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-row align="center" justify="end" class="my-3" no-gutters>
        <v-btn
          class="mr-0"
          color="primary"
          :disabled="!valid || !validPrice"
          @click="postProduct"
        >
          <v-icon left small>fa-save</v-icon>
          <span>Enregistrer le nouveau produit</span>
        </v-btn>
      </v-row>
    </section>
    <section class="loader pt-3" v-else>
      <v-row align="center" justify="center" no-gutters class="mt-3">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-row>
    </section>
  </v-container>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import { rulesMixin } from "@/mixins/rulesMixins";
import {
  RecipeProductFields,
  RecipeProductTagsEditor,
  RecipeProductPriceInput
} from "../components";
export default {
  mixins: [rulesMixin],
  name: "RecipeProductCreator",
  components: {
    RecipeProductFields,
    RecipeProductTagsEditor,
    RecipeProductPriceInput
  },
  computed: {
    ...mapGetters([
      "getAllowedUnits",
      "getIntermediateRecipe",
      "getOrganisationId",
      "getStoreId"
    ])
  },
  data() {
    return {
      product: {
        est_intermediaire: false,
        is_deleted: false,
        nom: null,
        data: {
          fk_product: null,
          store: null,
          tags: [],
          unite_mesure: null,
          unite_mesure_inventory: null,
          prix: 0,
          prix_inventory: 0,
          display_order: null,
          order_number: null,
          allergens: [],
          conversion_formula: null,
          use_conversion_formula: false,
          product_key: null,
          quantity_inventory: 1,
          quantity_production: null,
          use_order_quantity: false,
          price_order: null,
          quantity_order: null,
          quantity_inventory_order: null,
          unite_mesure_order: null,
          is_pinned: false
        }
      },
      valid: false,
      validPrice: false,
      id: null,
      tabs: 0
    };
  },
  methods: {
    async postProduct() {
      if (this.valid && this.validPrice) {
        try {
          this.$store.dispatch("startLoadingOverlay");
          const data = {
            ...this.product,
            organisation: this.getOrganisationId
          };
          data.data.store = this.getStoreId;
          await api.postRecipeProduct(data);
          this.$router.push({ name: "RecipeProductsIndex" });
        } finally {
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
